// extracted by mini-css-extract-plugin
module.exports = {"row":"CartCard-Row-module--row--1Yncp","noBorder":"CartCard-Row-module--no-border--vSCoB","marginTopSmall":"CartCard-Row-module--margin-top-small--3KmTB"};